import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OfferDetailsComponent } from '../../../../../components/admin-dashboard-component/promotions/offers-management/offer-details-component/offer-details-component';

@Component({
  selector: 'app-offer-details',
  imports: [OfferDetailsComponent],
  templateUrl: './offer-details.html',
  styleUrl: './offer-details.scss',
})
export class OfferDetails implements OnInit {
  private route = inject(ActivatedRoute);
  selectedOfferId = signal<string>('0');
  ngOnInit() {
    const offerId = this.route.snapshot.params['id'];
    if (offerId) {
      this.selectedOfferId.set(offerId);
    }
  }
}
